import { render } from "./IntegrationCustomFieldsSettings.vue?vue&type=template&id=6f0b3102"
import script from "./IntegrationCustomFieldsSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationCustomFieldsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__